import * as React from "react";

export const LockSvg = () => <svg width="40px" height="40px" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.06" cx="30.5" cy="30.5" r="30.5" fill="#804C80"/>
<path d="M36 28V26C36 23.2 33.8 21 31 21C28.2 21 26 23.2 26 26V28C24.3 28 23 29.3 23 31V38C23 39.7 24.3 41 26 41H36C37.7 41 39 39.7 39 38V31C39 29.3 37.7 28 36 28ZM28 26C28 24.3 29.3 23 31 23C32.7 23 34 24.3 34 26V28H28V26ZM32 36C32 36.6 31.6 37 31 37C30.4 37 30 36.6 30 36V33C30 32.4 30.4 32 31 32C31.6 32 32 32.4 32 33V36Z" fill="#804C80"/>
</svg>;



// WEBPACK FOOTER //
// ./src/images/LockSvg.tsx